import { template as template_9f75c8b599244bb7a26920c602de2f22 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/icon';
export default RouteTemplate(template_9f75c8b599244bb7a26920c602de2f22(`
  <@model.Component />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
